import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/Login.css";

export default function Login() {
  const { login, isAuthenticated, loading, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState("");

  if (isAuthenticated) {
    const redirectTo = location.state?.from?.pathname || "/";
    return <Navigate to={redirectTo} replace />;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLocalError("");

    if (!email.trim() || !password.trim()) {
      setLocalError("Please enter both email and password.");
      return;
    }
    if (password.length < 6) {
      setLocalError("Password must be at least 6 characters.");
      return;
    }

    try {
      await login(email, password);
      navigate("/", { replace: true });
    } catch {
      // error already set in context
    }
  }

  return (
    <div className="login-page">
      <div className="login-shell">
        <div className="login-brand-panel">
          <div className="login-brand-glow login-brand-glow-a" />
          <div className="login-brand-glow login-brand-glow-b" />

          <div className="login-brand-content">
            <div className="login-brand-mark"><img src="/assets/icon.png" alt="TT" /></div>
            <h2 className="login-brand-name">Today Talks</h2>
            <p className="login-brand-tagline">
              One place to write, publish, and manage every story across
              Business, Technology, Health, Sports, and more.
            </p>

            <ul className="login-brand-points">
              <li>
                <span className="login-brand-dot" />
                Create and edit posts by category
              </li>
              <li>
                <span className="login-brand-dot" />
                Control status and trending in one tap
              </li>
              <li>
                <span className="login-brand-dot" />
                Built for the editorial team only
              </li>
            </ul>
          </div>
        </div>

        <div className="login-form-panel">
          <form className="login-card" onSubmit={handleSubmit}>
            <span className="login-eyebrow">Admin Access</span>
            <h1 className="login-title">Welcome back</h1>
            <p className="login-subtitle">Sign in to manage your articles</p>

            {(localError || error) && (
              <div className="login-error">{localError || error}</div>
            )}

            <label className="login-label" htmlFor="email">
              Email address
            </label>
            <div className="login-input-wrap">
              <span className="login-input-icon">✉</span>
              <input
                id="email"
                type="email"
                className="login-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@todaytalks.in"
                autoComplete="username"
              />
            </div>

            <label className="login-label" htmlFor="password">
              Password
            </label>
            <div className="login-input-wrap">
              <span className="login-input-icon">🔒</span>
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                className="login-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-toggle-visibility"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>

            <button className="login-button" type="submit" disabled={loading}>
              {loading ? "Signing in..." : "Sign In"}
            </button>

            <p className="login-footnote">
              Access is limited to authorized Today Talks editors.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
